
angular.module('app').factory('Generator', ['$resource', function ($resource) {
	return $resource('/api/gen/:shortid', {}, {
		get: { url: '/api/gen/:shortid', method: 'GET' },
		save: { url: '/api/gen/:shortid', method: 'POST' }
	});
}]);